import { graphql } from 'react-relay';

export const ProjectListFragment = graphql`
    fragment ProjectListFragment on Query
    @argumentDefinitions(
        after: { type: "String" }
        first: { type: "Int" }
        page: { type: "Int", defaultValue: 1 }
        order_by: { type: "[String]" }
        filter_flexible: { type: "String" }
    ) {
        projects(after: $after, first: $first, page: $page, order_by: $order_by, filter_flexible: $filter_flexible)
            @connection(key: "ProjectFragment_projects") {
            edges {
                cursor
                node {
                    ...ProjectFragment
                    ...ProjectFragmentUsers
                }
            }
            ...ProjectConnectionFragment
        }
    }
`;
